import { orUndefined, schAlertType, schAloftArea } from '@aloft/toolkit-shared';

import { AlertDefinition } from '../../types.ts';
import {
  UnitRateFeatureCheck,
  checkInconsistentUnitRateAdjustments,
} from '../utils/checkInconsistentUnitRateAdjustments.ts';

const EXACT_MATCH_THRESHOLD = 0;
const BASEMENT_DEVIATION_THRESHOLD = 0.1;

const FEATURE_CHECKS: UnitRateFeatureCheck[] = [
  {
    label: 'bed',
    manualKey: 'bedrooms',
    unitRateKey: 'bedrooms',
    adjustmentCellKeyId: 'bedrooms',
    threshold: EXACT_MATCH_THRESHOLD,
    unit: 'bed',
    getUnitAmount: (editableData) => editableData.improvements?.bedrooms,
  },
  {
    label: 'full bath',
    manualKey: 'fullBaths',
    unitRateKey: 'fullBaths',
    adjustmentCellKeyId: 'fullBaths',
    threshold: EXACT_MATCH_THRESHOLD,
    unit: 'ba',
    getUnitAmount: (editableData) => editableData.improvements?.fullBaths,
  },
  {
    label: 'half bath',
    manualKey: 'halfBaths',
    unitRateKey: 'halfBaths',
    adjustmentCellKeyId: 'halfBaths',
    threshold: EXACT_MATCH_THRESHOLD,
    unit: 'ba',
    getUnitAmount: (editableData) => editableData.improvements?.halfBaths,
  },
  {
    label: 'basement',
    manualKey: 'basementTotal',
    unitRateKey: 'basementTotal',
    adjustmentCellKeyId: 'basementTotal',
    threshold: BASEMENT_DEVIATION_THRESHOLD,
    unit: 'SF',
    getUnitAmount: (editableData) =>
      orUndefined(schAloftArea.parse)(editableData.improvements?.basement?.totalArea)?.toSqFt()
        .unitAmount,
  },
  {
    label: 'Basement, Finished',
    manualKey: 'basementFinished',
    unitRateKey: 'basementFinished',
    adjustmentCellKeyId: 'basementFinished',
    threshold: BASEMENT_DEVIATION_THRESHOLD,
    unit: 'SF',
    getUnitAmount: (editableData) =>
      orUndefined(schAloftArea.parse)(editableData.improvements?.basement?.finishedArea)?.toSqFt()
        .unitAmount,
  },
];

export const inconsistentBedBathBasementAdjustmentRate: AlertDefinition = (params) =>
  checkInconsistentUnitRateAdjustments({
    ...params,
    alertType: schAlertType.enum.inconsistentBedBathBasementAdjustmentRate,
    severity: 'warning',
    featureChecks: FEATURE_CHECKS,
    fixingMethod: ['action'],
  });
